import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NbIconComponent } from '@nebular/theme';

@Component({
  selector: 'ubs-ofbiz-form-list-title',
  templateUrl: './ofbiz-form-list-title.component.html',
  styleUrls: ['./ofbiz-form-list-title.component.scss']
})
export class OfbizFormListTitleComponent implements OnInit {
  @Input() title:string;
  @Input() viewMode:string;
  open:boolean = true;

  @ViewChild("chevron", {read: ElementRef}) chevron: NbIconComponent;
  //@ViewChild("container", {read: ElementRef}) container: ElementRef;

  @Output() toggleContainer = new EventEmitter<boolean>();
  
  constructor() { }

  ngOnInit(): void {
  }

  togglePopover(){

  }

  toggleIcon(){
    this.open = !this.open;
    this.toggleContainer.emit(this.open);
  }

}
